import { RefObject, useEffect, useLayoutEffect, useState } from 'react';

// TODO: following principles of SOLID, this hook should be split into two hooks
export const useIsOverflowing = (
  ref: RefObject<HTMLElement>,
  maxLines?: number,
  callback?: (isOverflowing: boolean) => void,
): boolean => {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [resizeObserver, setResizeObserver] = useState<ResizeObserver | null>(
    null,
  );
  const trigger = () => {
    const { current } = ref || {};

    if (current) {
      let hasOverflow;
      if (maxLines) {
        const computedLineHeight = window.getComputedStyle(current).lineHeight;
        let lineHeight;

        if (computedLineHeight === 'normal') {
          const fontSizeInPx = window.getComputedStyle(current).fontSize;
          const fontSize = parseInt(fontSizeInPx, 10);
          lineHeight = 1.2 * fontSize;
          console.warn(
            'line-height is set to normal, which may cause unexpected behavior',
          );
        } else {
          lineHeight = parseInt(computedLineHeight, 10);
        }

        // number of lines * line height returns the max expected height
        hasOverflow = current.scrollHeight > maxLines * lineHeight;
      } else {
        hasOverflow = current.scrollHeight > current.clientHeight;
      }

      setIsOverflowing(hasOverflow);
      if (callback) callback(hasOverflow);
    }
  };

  useLayoutEffect(() => {
    if (ref.current && resizeObserver) {
      resizeObserver.unobserve(ref.current);
      resizeObserver.observe(ref.current);
    }
    trigger();
  }, [ref, callback]);

  useEffect(() => {
    if ('ResizeObserver' in window) {
      setResizeObserver(new ResizeObserver(trigger));
    }
    return () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, []);

  return isOverflowing;
};
